import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'has'})
export class HasPipe implements PipeTransform {
  transform(values: Array<any>, propertie: string): any {
    let result = values.filter((item) => {
      return item.hasOwnProperty(propertie);
    });

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/has-pipe.ts